import { Checkbox, FormControlLabel } from '@mui/material';
import { useCallback, useEffect, useMemo } from 'react';
import { TreeItem } from '@mui/x-tree-view';
import { Plan, ProductPlan, Provider, Rate, Option, Surcharge } from '../interfaces';
import { ISelectedRetailOption, ISelectedRetailSurcharge, SelectedRetails } from './EditProductModal';

interface IOptionsTreeItem {
	selectedRetails: SelectedRetails;
	setSelectedRetails: (retails: SelectedRetails) => void;
	setIsDeductiblesSelected: (bool: boolean) => void;
	isDeductiblesSelected: boolean;

	rate: Rate;
	product: ProductPlan;
	provider: Provider;
	plan: Plan;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	option: any;
	optionList: Map<string, ISelectedRetailOption> | Map<string, ISelectedRetailSurcharge>;
	isSurcharge: boolean;
}

const OptionsTreeItem = ({
	provider,
	plan,
	product,
	option,
	rate,
	selectedRetails,
	setSelectedRetails,
	setIsDeductiblesSelected,
	isDeductiblesSelected,
	optionList,
	isSurcharge,
}: IOptionsTreeItem) => {
	const { deductiblesSelected, dealsProductsMap } = selectedRetails;

	const localId = rate.rateId + (isSurcharge ? option.surchargeId : option.optionId);
	const options = optionList.get(localId);
	const finalId = isSurcharge
		? (options?.option as Surcharge)?.surchargeId || ''
		: (options?.option as Option)?.optionId || '';
	const isSelected = localId === (options?.rate?.rateId || '') + finalId;

	const isOptionSelectable = useMemo(() => deductiblesSelected.get(product.productTypeId)?.rate.rateId === rate.rateId || dealsProductsMap.get(product.productTypeId)?.rate.rateId === rate.rateId, [deductiblesSelected, product.productTypeId, rate.rateId, dealsProductsMap, selectedRetails]);

	useEffect(() => {
		const selectedProduct = dealsProductsMap.get(product.productTypeId);
		if (selectedProduct?.rate.rateId) {
			selectedProduct.options?.forEach((optionItem) => {
				if (localId === selectedProduct?.rate.rateId + optionItem.id) {
					optionList.set(localId, {
						provider,
						plan,
						rate,
						option,
						product,
					});
				}
			});
			setSelectedRetails({ ...selectedRetails });
		}
	}, [dealsProductsMap, localId, optionList]);

	const handleCheckChange = useCallback(() => {
		if (isOptionSelectable) {
			if (optionList.has(localId) && isSelected) {
				optionList.delete(localId);
			} else {
				optionList.set(localId, {
					provider,
					plan,
					rate,
					option,
					product,
				});
			}
		}
		setIsDeductiblesSelected(!isDeductiblesSelected);
		setSelectedRetails({ ...selectedRetails });
	}, [deductiblesSelected, optionList, rate, option, product, provider, plan, isSelected, selectedRetails]);

	return (
		<TreeItem
			itemId={localId}
			label={
				<FormControlLabel
					key={localId}
					label={option.optionDescription}
					control={<Checkbox size="small" checked={isSelected} onChange={handleCheckChange} />}
				/>
			}
		/>
	);
};

export default OptionsTreeItem;
